import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';

const categories = [
  {
    name: 'Cuts & styling',
    blurb:
      'Everyday cuts for women, men, and kids, finished with a blow-dry style so you leave looking like you mean it.',
    items: ['Women’s haircuts', 'Men’s haircuts', 'Children’s haircuts', 'Blow-dry styling'],
    images: ['/images/mens-150x150.jpeg', '/images/IMG_1754-150x150.jpg', '/images/child-150x150.jpeg', '/images/highlight-bob-150x150.jpeg'],
  },
  {
    name: 'Color & highlights',
    blurb:
      'Dimensional color, from a full single-process to hand-painted brightness and soft, grown-out-friendly lowlights.',
    items: ['Full color', 'Highlights', 'Lowlights', 'Color touch-up'],
    images: ['/images/color-150x150.jpeg', '/images/highlights-150x150.jpeg', '/images/silver-150x150.jpeg', '/images/color1-150x150.jpeg'],
  },
  {
    name: 'Balayage, ombré & smoothing',
    blurb:
      'Lived-in, sun-kissed color and the smoothing treatments that keep it easy to wear between visits.',
    items: ['Balayage', 'Ombré', 'Keratin treatments', 'Perms'],
    images: ['/images/rosegold-150x150.jpeg', '/images/aline-150x150.jpeg', '/images/IMG_1736-150x150.jpg', '/images/IMG_1751-150x150.jpg'],
  },
  {
    name: 'Color correction & vivids',
    blurb:
      'The bold stuff, and the rescues. Vivid fashion color, extensions for length and fullness, and corrections when something went sideways.',
    items: ['Color correction', 'Vivid colors', 'Extensions'],
    images: ['/images/rainbow-150x150.jpeg', '/images/Selena-pink-hair-150x150.jpeg', '/images/extentions-150x150.jpeg', '/images/correction-150x150.jpeg'],
  },
  {
    name: 'Bridal & special occasion',
    blurb:
      'Up-dos, bridal hair, and makeup for the days you want to feel unmistakably yourself, only more so.',
    items: ['Up-do styling', 'Bridal styling', 'Makeup'],
    images: ['/images/bridal1-150x150.jpeg', '/images/IMG_1753-150x150.jpg', '/images/bridal2-150x150.jpeg', '/images/updo-1-150x150.jpeg'],
  },
];

const Services = () => (
  <div className="page">
    <PageHero kicker="Services" title="Everything your hair might ask for.">
      Our services cover hair styling for women, men, and children. We take the
      time to understand what you are after before we get creative, so the look
      that walks out is unmistakably yours.
    </PageHero>

    <section className="section">
      <div className="container svc-cats">
        {categories.map((cat, i) => (
          <article className="svc-cat reveal" key={cat.name}>
            <div className="svc-cat__text">
              <span className="svc-cat__index">{String(i + 1).padStart(2, '0')}</span>
              <h2>{cat.name}</h2>
              <p className="lede">{cat.blurb}</p>
              <ul className="svc-cat__items">
                {cat.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="svc-cat__gallery">
              {cat.images.map((src, idx) => (
                <figure
                  className={`svc-cat__shot frame${idx === 0 ? ' svc-cat__shot--lead' : ''}`}
                  key={src}
                >
                  <img src={src} alt={`${cat.name} at The Loft Salon`} loading="lazy" />
                </figure>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>

    <section className="section--tight section--dark grain cta-band">
      <div className="container cta-band__inner">
        <div className="reveal">
          <span className="kicker">Ready when you are</span>
          <h2>Find the stylist for your look.</h2>
          <p className="lede">
            Each stylist books their own chair. Browse the team, find the work
            that matches what you want, and reach out directly.
          </p>
        </div>
        <div className="btn-row reveal" data-reveal="120">
          <Link to="/team" className="btn btn--primary">Meet the team</Link>
          <Link to="/contact" className="btn btn--outline">Contact us</Link>
        </div>
      </div>
    </section>
  </div>
);

export default Services;
